import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { ToggleSwitch } from '@/components/ui/toggle-switch'
import { useDesignVersionToggle } from '@/hooks'

import OrganisationManagersList from './OrganisationManagersList'
import OrganisationManager from './OrganisationManagerForm'

// TODO: remove this legacy master/detail page (and the Redux organisationManagers slice it feeds) once the new design is fully rolled out
const OrganisationManagers = () => {
  const { t } = useTranslation(['organisation'])
  const navigate = useNavigate()
  const params = useParams()

  const { redirect, toggle: handleUIToggle } = useDesignVersionToggle({
    group: 'managers',
    screen: 'Managers',
    to: { path: '/dashboard/organisation/managers' },
    version: 'legacy',
  })

  if (redirect) return redirect

  return (
    <div className="columns">
      <div className="ctp-organisation__design-toggle">
        <ToggleSwitch
          falsyLabel={t('organisation:managers.list.designToggle.old')}
          truthyLabel={t('organisation:managers.list.designToggle.new')}
          checked={false}
          onChange={handleUIToggle}
        />
      </div>
      <div className="column">
        <div className="ctp-short-toolbar-wrapper">
          <button
            className="button button-primary"
            onClick={() => navigate('/dashboard/organisation/managers/legacy/new')}
          >
            {t('organisation:shared.actions.addNew')}
          </button>
        </div>
        <OrganisationManagersList />
      </div>
      <div className="column">
        <OrganisationManager params={params} />
      </div>
    </div>
  )
}

export default OrganisationManagers
